import { useEffect } from 'react';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import useContentAccessLevel from 'src/hooks/useContentAccessLevel';

import { ComponentProps } from 'src/lib/ComponentProps';

import { parseAccessLevelRouteFields } from 'src/mappers/fields/parseAccessLevelContent';

type GaTrackAccessToContentProps = ComponentProps & {
	fields: {
		EventName: Field<string>;
	};
};

export default function GaTrackAccessToContent(props: GaTrackAccessToContentProps) {
	const { isAllowedAccessToContent } = useContentAccessLevel(parseAccessLevelRouteFields(props.rendering.fields));

	useEffect(() => {
		if (!props.fields) {
			return;
		}

		globalThis?.dataLayer?.push({
			event: props.fields.EventName.value,
			isAllowedAccessToContent: isAllowedAccessToContent,
		});
	}, [isAllowedAccessToContent]);

	return <></>;
}
